import type { AllPermissions } from '@hotjar/auth';
import { useAuthorizationWithUserId, usePermissionWithDependencies } from '@hotjar/auth';
import { useCurrentUser } from '@hotjar/user';
import { useCurrentSiteAccount } from '@hotjar/account';
import { useCurrentOrganization } from '@hotjar/webapp/hooks/useCurrentOrganization';
import { useCurrentSiteId } from '@hotjar/site';

export const useAuthorization = (): ReturnType<typeof useAuthorizationWithUserId> => {
  const { data } = useCurrentUser();
  return useAuthorizationWithUserId(data?.id);
};

export const usePermission = (
  permission: AllPermissions,
): ReturnType<typeof usePermissionWithDependencies> => {
  const { data: currentUser } = useCurrentUser();
  const currentUserId = currentUser?.id;

  const { data: currentSiteAccount } = useCurrentSiteAccount();
  const currentSiteAccountId = currentSiteAccount?.id;

  const { data: currentOrganization } = useCurrentOrganization();
  const currentOrganizationId = currentOrganization?.id;

  const currentSiteId = useCurrentSiteId() ?? undefined;

  return usePermissionWithDependencies(
    permission,
    currentUserId,
    currentSiteAccountId,
    currentOrganizationId,
    currentSiteId,
  );
};
